<div *ngIf="(seasonRanking$ | async) as seasonRanking" [hidden]="!seasonRanking || loading">
  <h4>
    {{seasonRanking.ranking.name}}
    <small>{{seasonRanking.ranking.description}}</small>
  </h4>

  <table class="table" *ngIf="(race$sRecord$ | async) as race$sRecord">
    <thead>
    <tr>
      <th class="position">#</th>
      <th class="start-number">Number</th>
      <th>Driver</th>
      <th *ngFor="let raceRanking of seasonRanking.raceRankings" class="race-name">
        <a
          [routerLink]="['/season/races/', raceRanking.race.racePlan._id | toUntypedId, 'rankings', raceRanking.ranking.id]">
          {{raceRanking.race.racePlan.name}}
          <small>{{raceRanking.race.racePlan.trackName}}</small>
        </a>
        <mc-progress-indicator [race$]="race$sRecord[raceRanking.race.racePlan._id]" class="progress-indicator"></mc-progress-indicator>
      </th>
      <th class="points">
        Points
      </th>
    </tr>
    </thead>

    <tbody>
    <tr *ngFor="let seasonStanding of seasonRanking.standings$ | async">
      <td class="position">{{seasonStanding.position}}.</td>
      <td class="start-number">{{seasonStanding.driver.startNumber}}</td>
      <td>{{seasonStanding.driver.name}}</td>
      <td *ngFor="let raceRanking of seasonRanking.raceRankings"
        class="race-standing"
        [class.not-classified]="!seasonStanding.raceStandings[raceRanking.race.racePlan._id]"
        [class.rejected]="seasonStanding.bestRaceStandings.indexOf(seasonStanding.raceStandings[raceRanking.race.racePlan._id]) < 0"
      >
        {{ seasonStanding.raceStandings[raceRanking.race.racePlan._id]?.seasonPoints || 0 }}
        <small>{{ seasonStanding.raceStandings[raceRanking.race.racePlan._id] ? '(P' + seasonStanding.raceStandings[raceRanking.race.racePlan._id].position + ')' : '' }}</small>
      </td>
      <td class="points">
        {{seasonStanding.points}}
      </td>
    </tr>
    </tbody>
  </table>
</div>

<div *ngIf="loading">Loading...</div>
